import React from 'react';
import { acpNoOptions } from './utils';

interface NoColumnProps {
  noValue: string | null;
  setNoValue: React.Dispatch<React.SetStateAction<string | null>>;
}

const NoColumn: React.FC<NoColumnProps> = ({ noValue, setNoValue }) => {
  return (
    <div
      className="govuk-radios care-status__radios mb-5"
      data-module="govuk-radios"
    >
      {acpNoOptions.map(option => {
        return (
          <div className="govuk-radios__item" key={option.value}>
            <input
              className="govuk-radios__input"
              id={option.value}
              name={option.value}
              type="radio"
              value={option.value}
              checked={noValue === option.value}
              onChange={e => {
                setNoValue(e.target.value);
              }}
            />
            <label
              className="govuk-label govuk-radios__label"
              htmlFor={option.value}
            >
              {option.label}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default NoColumn;
